import { ReCaptchaProvider } from 'next-recaptcha-v3';

import { ENV } from '@/environment/client';

import { SignupForm } from '../CrossChainSwaps/SignupForm';
import { MarketingPageHeader } from '../Header/MarketingPageHeader';
import { Footer } from '../Landing/LandingFooter';
import { LandingHelp } from '../Landing/LandingHelp';
import { GetToKnowHeroSection } from './GetToKnowHeroSection';
import { MatchaIndexSection } from './MatchaIndexSection';
import { MatchaTeamSection } from './MatchaTeamSection';
import { OurCultureSection } from './OurCultureSection';
import { OurStorySection } from './OurStorySection';

export const AboutMatcha = () => {
  return (
    <ReCaptchaProvider reCaptchaKey={ENV.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY}>
      <MarketingPageHeader />
      <GetToKnowHeroSection />
      <main
        className="ml-[1.125rem] mr-[1.125rem] tablet:ml-[4.25rem] tablet:mr-[4.25rem] desktop:ml-auto desktop:mr-auto desktop:p-4 pb-0 -mt-[90px] tablet:mt-0"
        data-lock-theme="true"
      >
        <MatchaIndexSection />
        <OurStorySection />
        <MatchaTeamSection />
        <OurCultureSection />
        <div className="ml-auto mr-auto w-full max-w-[1240px]">
          <SignupForm />
        </div>
        <LandingHelp />
      </main>
      <Footer />
    </ReCaptchaProvider>
  );
};
